import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../utils/auth"; // ✅ Import useAuth()

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();  // ✅ Centralized authentication

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
